import React, { useEffect, useState } from 'react'
import { useMutation, useQuery } from 'react-query'
// import { Button } from '@offerzen/pinata'

import { restClient } from 'config/restClient'

import styles from './styles'

const getCookieBannerStatus = async () => {
  const response = await restClient('/api/cb', {
    method: 'GET',
  })

  return response.data
}

const updateCookieBannerStatus = async () => {
  const response = await restClient('/api/cb?accepted=true', {
    method: 'GET',
  })

  return response.data
}

const hasAcceptedCookie = () => !!document.cookie.split(';').find(row => row.startsWith('_zadev_cb_acc='))

function CookieAcceptBanner() {
  const [showBanner, setShowBanner] = useState(!hasAcceptedCookie())
  const [showHiddenSuccess, setShowHiddenSuccess] = useState()

  const { status: fetchCookieBannerStatus } = useQuery(
    ['cookieBannerStatus'],
    () => getCookieBannerStatus(),
    {
      enabled: showBanner,
      refetchOnWindowFocus: false,
      onSuccess: data => {
        setShowBanner(data.show_cookie_banner)
      },
    },
  )

  // eslint-disable-next-line no-unused-vars
  const { mutate: acceptCookie } = useMutation(
    () => {
      updateCookieBannerStatus()
      setShowHiddenSuccess(true)
      setShowBanner(false)
    },
  )

  useEffect(() => {
    let successMessageTimeout
    if (showHiddenSuccess) {
      successMessageTimeout = setTimeout(() => {
        setShowHiddenSuccess(false)
      }, 5000)
    }

    return () => clearTimeout(successMessageTimeout)
  }, [showHiddenSuccess, setShowHiddenSuccess])

  if (showHiddenSuccess) {
    return (
      <p role="status" className={styles.hiddenSuccessMessage}>Cookie set successfully</p>
    )
  }

  if (!showBanner || fetchCookieBannerStatus === 'loading') return null

  return null

  /* TODO: @team:growth @kay @due:2024-06-01
  * @details: We need urgently move from self-managed cookies to granular cookie control.
  * https://offerzen.slack.com/archives/CMNMA8PLJ/p1708089108934689
  * @action: Clean up the code and remove the commented out code once the new cookie banner is live
  */
  // return (
  //   <div
  //     role="dialog"
  //     aria-label="Cookie notice"
  //     tabIndex="-1"
  //     className={styles.container}
  //   >
  //     <p id="cookie-banner-text" className={styles.text}>
  //       OfferZen uses cookies to improve your experience, and for measurement and analytics purposes.
  //       &nbsp;By using our website and our services, you agree to our use of cookies as described in our
  //       &nbsp;<a className={styles.link} href="/cookie-declaration">Cookie Declaration.</a>
  //     </p>
  //     <Button onClick={acceptCookie} label="Accept" />
  //   </div>
  // )
}

export default CookieAcceptBanner
